import {
  constantRouterMap
} from '@/router/routers'
import Layout from '@/layout'
const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    sidebarRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
    SET_SIDEBAR_ROUTERS: (state, routers) => {
      state.sidebarRouters = constantRouterMap.concat(routers);
    },
    CHANGE_SIDEBAR_ROUTERS: (state, routers) => {
      state.sidebarRouters = routers
    }
  },
  actions: {
    GenerateRoutes({
      commit
    }, asyncRouter) {

      commit('SET_ROUTERS', asyncRouter)
    },
    SetSidebarRouters({
      commit
    }, sidebarRouter) {
      commit('SET_SIDEBAR_ROUTERS', sidebarRouter)
    },
    ChangeSidebarRouters({
      commit
    }, sidebarRouter) {
      commit('CHANGE_SIDEBAR_ROUTERS', sidebarRouter)
    }
  }
}
export const filterAsyncRouter = (routers, lastRouter = false, type = false) => {
  return routers.filter(router => {
    router.alwaysShow = true
    if (router.component) {
      if (router.component === 'Layout') { //Layout组件特殊处理
        router.component = Layout
      } else {
        router.component = loadView(router.component)
      }
    } else {
      router.component = Layout
    }
    if (router.children != null && router.children && router.children.length) {
      router.alwaysShow = true
      router.children = filterAsyncRouter(router.children, router, type)
    } else {
      delete router['children']
      delete router['redirect']
    }
    return true


  })
}
export const filterRouter = (routers, lastRouter = false, type = false) => {
  return routers.filter(router => {
    router.alwaysShow = true

    if (router.component) {
      if (router.component === 'Layout') { //Layout组件特殊处理
        router.component = Layout
      } else {
        router.component = loadView(router.component)
      }
    } else {
      router.component = Layout
    }
    if (router.children != null && router.children && router.children.length) {
      router.alwaysShow = true
      router.children = filterAsyncRouter(router.children, router, type)
    } else {
      delete router['children']
      delete router['redirect']
    }
    return true


  })
}
// export const LfilterAsyncRouter = (router => {
//   router.alwaysShow = true
//   if (router.component) {
//     if (router.component === 'Layout') { //Layout组件特殊处理
//       router.component = Layout
//     } else {
//       router.component = loadView(router.component)
//     }
//   } else {
//     router.component = Layout
//   }
//   if (router.children != null && router.children && router.children.length) {
//     router.alwaysShow = true
//     router.children = LfilterAsyncRouter(router.children, router, type)
//   } else {
//     delete router['children']
//     delete router['redirect']
//   }
//   return true
// })
// function filterChildren(childrenMap, lastRouter = false) {
//   var children = []
//   childrenMap.forEach((el, index) => {
//     if (el.children && el.children.length) {
//       if (el.component === 'ParentView') {
//         el.children.forEach(c => {
//           if (el.path && c.path) {
//             c.path = el.path + '/' + c.path
//           }

//           if (c.children && c.children.length) {
//             children = children.concat(filterChildren(c.children, c))
//             return
//           }
//           children.push(c)
//         })
//         return
//       }
//     }
//     if (lastRouter) {
//       if (lastRouter.path && el.path) {
//         el.path = lastRouter.path + '/' + el.path
//       }

//     }
//     children = children.concat(el)
//   })
//   return children
// }

export const loadView = (view) => {
  return (resolve) => require([`@/view/${view}`], resolve)
}
export default permission